/* Ayudate · Red de seguridad
   Si un componente falla, sin esto la página queda en blanco y la persona
   no sabe qué pasó ni qué hacer. Envuelve al enrutador en App.jsx. */

import React from "react";
import { Marca } from "./Marca";
import { ESTILOS_MINIMOS } from "../estilos/minimos";
import { CONTACTO } from "../datos/contacto";

export class ErrorBoundary extends React.Component {
  constructor(p) { super(p); this.state = { rota: false }; }
  static getDerivedStateFromError() { return { rota: true }; }
  componentDidCatch(err, info) { console.error("Ayudate · fallo:", err, info); }

  render() {
    if (!this.state.rota) return this.props.children;
    return (
      <div className="v2">
        <style>{ESTILOS_MINIMOS}</style>
        <div className="mini-wrap">
          <div className="logo" style={{ marginBottom: 28 }}><Marca /></div>
          <div className="mini-card">
            <h1>Ocurrió un problema de conexión o carga</h1>
            <p>
              No es culpa suya. La página tuvo un problema y no pudo seguir. Recárguela y vuelva a
              intentar; casi siempre con eso se arregla.
            </p>
            <button className="btn btn-p" style={{ width: "100%", marginBottom: 10 }}
              onClick={() => window.location.reload()}>
              Recargar página
            </button>
            <a className="btn" href="/"
              style={{ width: "100%", textAlign: "center", display: "block" }}>
              Volver al inicio
            </a>
            <p style={{ marginTop: 18, marginBottom: 0, fontSize: 16 }}>
              Si vuelve a pasar, escríbanos por WhatsApp al {CONTACTO.whatsappVisible} y lo
              revisamos.
            </p>
          </div>
        </div>
      </div>
    );
  }
}
